// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { readFile } from "../../utils/utilities";

export class JsonImportPlugin {

  async tryLoad(file) {
    if (!file.name.endsWith(".json")) {
      return false;
    }

    const data = await readFile(file);

    // Support standard export format
    if (data.digitalTwinsFileInfo && data.digitalTwinsFileInfo.fileVersion === "1.0.0" && data.digitalTwinsGraph) {
      return data;
    }

    // Support simple array format
    if (Array.isArray(data)) {
      const result = {
        digitalTwinsFileInfo: { fileVersion: "1.0.0" },
        digitalTwinsGraph: {
          digitalTwins: [],
          relationships: []
        }
      };

      data.forEach(item => {
        if (item.$dtId && item.$metadata && item.$metadata.$model) {
          result.digitalTwinsGraph.digitalTwins.push(item);
        } else if (item.$relationshipId || (item.$sourceId && item.$targetId && item.$relationshipName)) {
          result.digitalTwinsGraph.relationships.push(item);
        }
      });

      if (result.digitalTwinsGraph.digitalTwins.length > 0 || result.digitalTwinsGraph.relationships.length > 0) {
        return result;
      }
    }

    throw new Error("Unexpected JSON contents");
  }

}
